import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { setModal, clearModal } from '../../store/modal';

import { getArrays, intersect } from 'lib';
import { updateDataArray } from 'store/dataArray';

import {
  setCheckoutPlanParams,
  updateCheckoutPlanParams
} from '../../store/checkoutPlanParams';
import {
  setCheckoutMealPlan,
  updateCheckoutMealPlan
} from '../../store/checkoutMealPlan';
import { userUpdate } from '../../store/user';
import { spin, stop } from '../../store/spinner';

import OrderSummary from '../../components/Checkout/OrderSummary';

import MealProgress from 'components/Checkout/mealplan/MealProgress';
import DietGroups from 'components/Checkout/mealplan/DietGroups';
import DietTypes from 'components/Checkout/mealplan/DietTypes';
import MealTypes from 'components/Checkout/mealplan/MealTypes';
import Schedule from 'components/Checkout/mealplan/Schedule';
import Duration from 'components/Checkout/mealplan/Duration';
import Delivery from 'components/Checkout/mealplan/Delivery';
import Extras from 'components/Checkout/mealplan/Extras';
import Preferences from 'components/Checkout/mealplan/Preferences';
import headImg1 from 'assets/grid-head-img1.png';
import headImg2 from 'assets/grid-head-img2.png';
import headImg3 from 'assets/grid-head-img3.png';
import LoseweightIcon from 'assets/lose-weight-plan.svg';
import BuildStrengthIcon from 'assets/build-strength-gain-muscle.svg';
import HealthyIcon from 'assets/healthy-balanced-living.svg';
import PlantIcon from 'assets/plant-based-lifestyle.svg';
import 'styles/CustomMealPlan.css';
import SampleMenu from '../../components/Checkout/mealplan/samplemenu';
class MealPlans extends Component {
  constructor(props) {
    super(props);

    let checkoutPlanParams = props.checkoutPlanParams || {};
    let checkoutMealPlan = props.checkoutMealPlan;
    let dataArray = props.dataArray || {};
    let planParams = props.planParams || {};
    let prevMealType = checkoutPlanParams.mealTypes;
    let daysCount = checkoutPlanParams.days_count;
    let excluded = checkoutPlanParams.exclude_week_day;
    let mealPlanId = checkoutPlanParams.mealPlan_id;
    let dietGroup = checkoutPlanParams.diet_group;
    let dietId = checkoutPlanParams.diet_id;
    let emirateId = checkoutPlanParams.emirate;
    let slotId = checkoutPlanParams.slot_id;

    if (checkoutMealPlan && Object.keys(checkoutMealPlan).length > 0) {
      browserHistory.push('/checkout/menus');
    }

    let combinations = dataArray.mealtypeMobCombinations || {};
    let combination = false;

    if (
      prevMealType &&
      combinations[prevMealType.join('-')] !== undefined
    ) {
      combination = combinations[prevMealType.join('-')];
    }

    let rangeId = this.getDayRangeId(daysCount);

    let minDate = moment().add(3, 'days').utc().startOf('day');

    if (
      planParams &&
      planParams.end_date !== undefined &&
      minDate.unix() < planParams.end_date
    ) {
      minDate = moment.unix(planParams.end_date).add(1, 'day');
    }

    let defaultDate = checkoutPlanParams.start_date || minDate.unix();

    if (defaultDate < minDate.unix()) {
      defaultDate = minDate.unix();
    }

    let emirateObj = dataArray.emirate;
    let emirateSlots = dataArray.emirateSlots;

    let emirateValue = emirateObj
      ? { label: emirateObj[emirateId], value: emirateId }
      : '';

    let slotValue = '';
    let slotList = [];

    if (emirateSlots && emirateId && emirateSlots[emirateId]) {
      if (slotId) {
        let selectedSlot = emirateSlots[emirateId].find(function(item) {
          return item.id == slotId;
        });
        if (selectedSlot) {
          slotValue = {
            label: selectedSlot.display_name,
            value: slotId
          };
        }
      }

      emirateSlots[emirateId].forEach(function(item) {
        slotList.push({
          label: item.display_name,
          value: item.id
        });
      });
    }

    let bagPrice =
      checkoutPlanParams.bag_price !== undefined
        ? checkoutPlanParams.bag_price || 180
        : 180;

    let dietListByGroup = dataArray.dietListByGroup || [];
    let dietGroupList =
      dietListByGroup.find(function(item) {
        return item.id == dietGroup || item.id == 1;
      }) || {};

    this.state = {
      diet: dietId || 39,
      priceType: 0,
      diet_group: dietGroup || 1,
      dietGroupList: dietGroupList,
      sampleData:[],
      ingredientListData: [],
      dietHandle: 'keto',

      dislikes: [],
      eliminate_groups: [],

      mealType: prevMealType || [3, 5],
      dayCount: daysCount || 20,

      selectedDay:
        daysCount > 0 &&
        [5, 6, 20, 24, 30, 40, 60].indexOf(parseInt(daysCount, 10)) === -1
          ? {
              label: daysCount + ' Days',
              value: daysCount
            }
          : [],

      excluded: excluded || ['6', '0'],
      mealplanId: mealPlanId || 71,
      dayRangeId: rangeId || null,
      mealTypeCom: combination || null,

      deliveryDate: defaultDate,
      minDate: minDate.unix(),

      emirate_id: emirateId,
      emirate: emirateValue,

      slot_id: slotId,
      slot: slotValue,

      emirateList: [],
      slotList: slotList,

      bag_price: bagPrice,
      weekday: 5,
      activeStep: 0
    };

    this.steps = [
      { id: 'goal', number: '01', label: 'Goal' },
      { id: 'meals', number: '02', label: 'Meals' },
      { id: 'schedule', number: '03', label: 'Schedule' },
      { id: 'duration', number: '04', label: 'Duration' },
      { id: 'delivery', number: '05', label: 'Delivery' },
      { id: 'extras', number: '06', label: 'Extras' }
    ];
    this.dietGroupIcons={1:'<svg width="31" height="36" viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.3701 6.02594H27.2084L27.4251 5.83188C27.7144 5.57285 27.739 5.12833 27.4799 4.83899C27.2209 4.54966 26.7763 4.52512 26.4871 4.78415L24.9 6.20517C24.751 6.33855 24.6659 6.52903 24.6659 6.72899C24.6659 6.92896 24.751 7.11944 24.9 7.25282L26.4871 8.67384C26.6213 8.794 26.7888 8.85314 26.9558 8.85314C27.1488 8.85314 27.3411 8.7741 27.4799 8.61899C27.739 8.32973 27.7144 7.88514 27.4251 7.62611L27.2084 7.43205H29.3701C29.7584 7.43205 30.0732 7.11726 30.0732 6.72892C30.0732 6.34059 29.7584 6.02594 29.3701 6.02594Z" fill="#58585A"></path><path d="M3.58608 8.67397L5.1731 7.25295C5.32209 7.11957 5.40724 6.92909 5.40724 6.72912C5.40724 6.52915 5.32209 6.33868 5.1731 6.20529L3.58608 4.78428C3.29674 4.52525 2.85223 4.54986 2.59319 4.83912C2.33416 5.12839 2.3587 5.57297 2.64804 5.83201L2.86474 6.02607H0.703125C0.314789 6.02607 0 6.34086 0 6.72919C0 7.11753 0.314789 7.43232 0.703125 7.43232H2.86481L2.64811 7.62638C2.35877 7.88541 2.33423 8.32993 2.59327 8.61926C2.73213 8.77437 2.9243 8.8534 3.11737 8.8534C3.2843 8.85319 3.45192 8.79413 3.58608 8.67397Z" fill="#58585A"></path><path d="M24.8068 11.4363C24.7556 11.3643 24.7051 11.2917 24.6554 11.2186C22.6799 8.31491 22.167 4.55029 23.2836 1.14826L23.3576 0.922627C23.4787 0.553631 23.2777 0.15637 22.9088 0.0352935C22.5398 -0.0857129 22.1426 0.115097 22.0215 0.484093L21.9475 0.709723C21.3325 2.58332 21.1448 4.59817 21.4047 6.53645C21.6438 8.32005 22.2639 10.0488 23.206 11.5682L22.9024 11.7218C20.458 12.8736 17.7385 13.4823 15.0364 13.4823C12.3347 13.4823 9.61485 12.8735 7.17061 11.7218L6.867 11.5681C7.80911 10.0487 8.42919 8.31991 8.66825 6.53638C8.92805 4.5981 8.74039 2.58325 8.12551 0.709582L8.05147 0.483952C7.93033 0.114957 7.533 -0.0859942 7.16414 0.0351529C6.79521 0.15623 6.59426 0.553561 6.71534 0.922486L6.78938 1.14805C7.90593 4.55008 7.39307 8.3147 5.41746 11.2186C5.36782 11.2916 5.3174 11.364 5.26622 11.436C3.84564 13.4337 2.96717 15.7734 2.72572 18.2024C2.48419 20.6317 2.88532 23.0958 3.88572 25.3281L8.48143 35.584C8.59836 35.845 8.85485 35.9998 9.12345 35.9998C9.21956 35.9998 9.31715 35.98 9.41053 35.9381C9.7649 35.7794 9.92345 35.3633 9.76462 35.0089L5.16898 24.7532C4.56205 23.3988 4.20992 21.9644 4.10579 20.519C8.88874 20.6635 11.6665 22.3369 13.1709 23.7508C13.5093 24.0688 13.9101 24.2857 14.3334 24.4012V35.2967C14.3334 35.685 14.6482 35.9998 15.0365 35.9998C15.4248 35.9998 15.7396 35.685 15.7396 35.2967V24.4188C16.175 24.3116 16.5887 24.0978 16.938 23.7772C18.4888 22.3533 21.2959 20.6683 25.9671 20.5195C25.8629 21.9647 25.5108 23.3989 24.9039 24.7531L20.3083 35.0092C20.1494 35.3635 20.308 35.7796 20.6624 35.9383C20.7557 35.9802 20.8534 36 20.9494 36C21.218 36 21.4745 35.8452 21.5915 35.5842L26.1872 25.3283C27.1876 23.0959 27.5886 20.6319 27.3471 18.2026C27.1057 15.7736 26.2273 13.4338 24.8068 11.4363ZM15.9869 22.7413C15.4659 23.2196 14.652 23.2129 14.134 22.7261C12.4436 21.1374 9.34422 19.2555 4.08252 19.1115C4.16907 16.8773 4.8428 14.6703 6.07846 12.7451L6.54434 12.9809C6.55011 12.9839 6.55601 12.9868 6.56185 12.9895C9.19481 14.2319 12.1253 14.8885 15.0365 14.8885C17.9477 14.8885 20.8782 14.2319 23.5112 12.9895C23.5171 12.9867 23.5229 12.9839 23.5287 12.9809L23.9946 12.7451C25.2303 14.6704 25.9041 16.8776 25.9905 19.112C20.8493 19.2597 17.7229 21.1475 15.9869 22.7413Z" fill="#58585A"></path><path d="M15.0366 10.8119C15.425 10.8119 15.7397 10.4971 15.7397 10.1088V9.22813C15.7397 8.8398 15.425 8.52501 15.0366 8.52501C14.6483 8.52501 14.3335 8.8398 14.3335 9.22813V10.1088C14.3335 10.4971 14.6483 10.8119 15.0366 10.8119Z" fill="#58585A"></path></svg>',2:'<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.8983 4.45719C25.8983 4.45719 25.8877 4.45187 25.8824 4.44656C24.5542 2.41188 22.2592 1.0625 19.6561 1.0625C15.5549 1.0625 12.2186 4.39875 12.2186 8.5C12.2186 12.6012 15.5549 15.9375 19.6561 15.9375C20.6708 15.9375 21.643 15.7303 22.5249 15.3584C22.6789 17.1753 22.5939 18.8594 22.4558 20.1663C21.8874 19.8263 21.2764 19.55 20.6124 19.3747C18.4396 18.8009 16.0383 19.2578 14.0567 20.57C13.1908 19.0134 11.7936 17.8447 10.0458 17.3134C7.20361 16.4528 4.10111 17.3453 1.74768 19.6934C1.54049 19.9006 1.54049 20.2406 1.74768 20.4478C1.95486 20.655 2.29486 20.655 2.50205 20.4478C4.57393 18.3759 7.27799 17.5844 9.73768 18.3334C11.8786 18.9816 13.3661 20.6603 13.823 22.95C13.8708 23.1997 14.0939 23.375 14.3436 23.375C14.3755 23.375 14.4127 23.3697 14.4499 23.3644C14.7367 23.3059 14.9227 23.0297 14.8642 22.7375C14.7792 22.3231 14.6571 21.93 14.5136 21.5475C16.2667 20.3256 18.413 19.89 20.3414 20.4053C22.2221 20.8994 23.6883 22.2169 24.4799 24.1134C24.5649 24.3153 24.7614 24.4375 24.9686 24.4375C25.0377 24.4375 25.1067 24.4269 25.1705 24.395C25.4414 24.2834 25.5742 23.9753 25.4574 23.7044C24.9846 22.5675 24.2992 21.6166 23.4439 20.8728C23.6352 19.3588 23.7839 17.1859 23.5396 14.8325C25.6433 13.5363 27.0564 11.2253 27.0883 8.585C28.9477 12.3409 31.4021 18.9922 31.3436 27.8959C31.3383 28.5387 30.9611 29.1178 30.3821 29.3675C27.423 30.6425 19.433 33.3413 9.1533 30.8709C8.87174 30.8019 8.58486 30.9772 8.5158 31.2641C8.44674 31.5456 8.62205 31.8325 8.90893 31.9016C12.0114 32.6506 14.9174 32.9375 17.5524 32.9375C23.8902 32.9375 28.6449 31.2747 30.8017 30.3397C31.7686 29.9253 32.3955 28.9691 32.4061 27.9066C32.5017 13.2866 26.1692 4.81313 25.8983 4.45719ZM19.6561 12.75C17.3133 12.75 15.4061 10.8428 15.4061 8.5C15.4061 6.15719 17.3133 4.25 19.6561 4.25C21.9989 4.25 23.9061 6.15719 23.9061 8.5C23.9061 10.8428 21.9989 12.75 19.6561 12.75Z" fill="#3A6659"></path><path d="M19.6562 10.0938C20.5365 10.0938 21.25 9.3802 21.25 8.5C21.25 7.6198 20.5365 6.90625 19.6562 6.90625C18.776 6.90625 18.0625 7.6198 18.0625 8.5C18.0625 9.3802 18.776 10.0938 19.6562 10.0938Z" fill="white"></path><path d="M17.5738 29.7553C19.072 29.7553 20.5754 29.6544 22.0417 29.4472C22.3338 29.4047 22.5357 29.1391 22.4932 28.8469C22.4507 28.5547 22.1798 28.3528 21.8929 28.3953C18.9285 28.8044 15.8526 28.7885 12.8298 28.3422C12.5429 28.2997 12.272 28.5016 12.2242 28.7885C12.1763 29.0753 12.3835 29.3463 12.6704 29.3941C14.296 29.6331 15.9429 29.7553 17.5685 29.7553H17.5738Z" fill="white"></path></svg>',3:'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12.1504C18.0713 12.1504 19.8714 13.3363 20.7568 15.0684L20.7979 15.1504H30C30.4672 15.1504 30.8496 15.5328 30.8496 16C30.8496 16.4672 30.4672 16.8496 30 16.8496H21.2998L21.3213 17.0186C21.3405 17.1719 21.3496 17.3357 21.3496 17.5V24.1504H25C25.4672 24.1504 25.8496 24.5328 25.8496 25V28.5C25.8496 29.7972 24.7972 30.8496 23.5 30.8496H8.5C7.20284 30.8496 6.15039 29.7972 6.15039 28.5V25C6.15039 24.5328 6.53284 24.1504 7 24.1504H10.6504V17.5C10.6504 17.3359 10.669 17.1811 10.6797 17.0098L10.6895 16.8496H2C1.53284 16.8496 1.15039 16.4672 1.15039 16C1.15039 15.5328 1.53284 15.1504 2 15.1504H11.2021L11.2432 15.0684C12.1286 13.3363 13.9287 12.1504 16 12.1504ZM7.84961 28.5C7.84961 28.8628 8.13716 29.1504 8.5 29.1504H23.5C23.8628 29.1504 24.1504 28.8628 24.1504 28.5V25.8496H7.84961V28.5ZM16 13.8496C13.9872 13.8496 12.3496 15.4872 12.3496 17.5V24.1504H19.6504V17.5C19.6504 15.4872 18.0128 13.8496 16 13.8496Z" fill="#595955" stroke="white" stroke-width="0.3"></path><path d="M23.1699 1.15039H24.8203C27.3075 1.15056 29.3398 3.17311 29.3398 5.66992V6.15039H29.9902C30.4573 6.15052 30.8398 6.53292 30.8398 7C30.8398 7.46708 30.4573 7.84948 29.9902 7.84961H29.3398V9C29.3398 10.5674 28.067 11.8495 26.4902 11.8496H21.5C19.9325 11.8496 18.6504 10.5768 18.6504 9V7.84961H18C17.5328 7.84961 17.1504 7.46716 17.1504 7C17.1504 6.53284 17.5328 6.15039 18 6.15039H18.6504V5.66992C18.6504 3.18262 20.673 1.15043 23.1699 1.15039ZM20.3604 9C20.3604 9.63276 20.877 10.1503 21.5098 10.1504H26.5C27.0818 10.1504 27.5644 9.71267 27.6387 9.15039H27.6602V7.84961H20.3604V9ZM23.1699 2.86035C21.6674 2.86039 20.4358 4.04663 20.3574 5.53027H20.3398V6.16016H27.6396V5.67969C27.6395 4.12709 26.3729 2.86052 24.8203 2.86035H23.1699Z" fill="#595955" stroke="white" stroke-width="0.3"></path><path d="M2.00049 1.14038H10.0103C10.2475 1.14044 10.4774 1.2419 10.6392 1.42065C10.8002 1.59873 10.8765 1.83631 10.8511 2.07397V2.07495L10.1011 9.72534C9.97859 10.9389 8.97258 11.8502 7.76025 11.8503H4.25049C3.11381 11.8503 2.15869 11.0491 1.94287 9.94897L1.90967 9.72534L1.15967 2.07495V2.07397L1.15479 1.98511C1.15452 1.77788 1.23055 1.57653 1.37158 1.42065C1.53335 1.24193 1.76325 1.14038 2.00049 1.14038ZM3.34033 7.0144L3.59033 9.56421L3.59131 9.56714C3.62986 9.90122 3.9022 10.15 4.23975 10.1501H7.76025V10.1492C8.09323 10.1442 8.36075 9.89795 8.39893 9.56714V9.56421L8.64893 7.0144L8.66553 6.85034H3.32471L3.34033 7.0144ZM2.95068 3.01538L3.15088 5.01538L3.16455 5.15015H8.83545L8.84912 5.01538L9.04932 3.01538L9.06592 2.85034H2.93408L2.95068 3.01538Z" fill="#595955" stroke="white" stroke-width="0.3"></path><path d="M16.5 18H15.5C14.95 18 14.5 18.45 14.5 19C14.5 19.55 14.95 20 15.5 20H16.5C17.05 20 17.5 19.55 17.5 19C17.5 18.45 17.05 18 16.5 18Z" fill="#595955"></path></svg>',4:'<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_211_1400)"><path d="M33.3667 17.8188C33.6998 16.5272 33.3434 15.1218 32.3649 14.1397C32.3416 14.1163 32.3181 14.0934 32.2943 14.0706C33.313 12.8567 33.2531 11.0354 32.1147 9.89285C31.5318 9.30788 30.7567 8.98581 29.9321 8.98581C29.1982 8.98581 28.5036 9.24088 27.9488 9.70931C27.9272 9.68653 27.9053 9.66402 27.8831 9.6417C27.159 8.91502 26.1961 8.51479 25.1718 8.51479C24.1474 8.51479 23.1845 8.91495 22.4604 9.6417C22.2711 9.83169 22.1037 10.0385 21.9594 10.2603C21.5179 10.1299 21.0599 10.0641 20.5916 10.0641C20.3445 10.0641 20.1017 10.0828 19.8645 10.1187C19.6842 9.87672 19.4774 9.6587 19.2494 9.46779C20.1704 8.89928 20.7857 7.88001 20.7857 6.71956C20.7857 5.44543 20.0417 4.31201 18.9196 3.79191C18.9202 3.76635 18.9205 3.74078 18.9205 3.71528C18.9205 1.93639 17.4749 0.489197 15.698 0.489197C13.9212 0.489197 12.4756 1.93639 12.4756 3.71528C12.4756 3.74085 12.4759 3.76641 12.4765 3.79191C11.3544 4.31201 10.6104 5.44543 10.6104 6.71956C10.6104 7.17936 10.7069 7.61698 10.8809 8.01316C10.4365 7.91269 9.9778 7.86149 9.51011 7.86149C7.40968 7.86149 5.4485 8.94404 4.31813 10.7069C2.04784 10.996 0.286742 12.9457 0.286742 15.3003C0.286742 16.2006 0.552898 17.0755 1.03169 17.818H0.664062C0.297301 17.818 0 18.1153 0 18.482C0 18.8487 0.297301 19.1461 0.664062 19.1461H1.01695C1.0538 21.1915 1.47747 23.1204 2.27773 24.8838C3.08059 26.653 4.24117 28.2133 5.72721 29.5214C8.64955 32.094 12.653 33.5107 17 33.5107C21.347 33.5107 25.3504 32.094 28.2728 29.5215C29.7589 28.2135 30.9194 26.6531 31.7223 24.8839C32.5225 23.1205 32.9461 21.1916 32.9831 19.1462H33.3359C33.7026 19.1462 34 18.8489 34 18.4822C34 18.1258 33.7192 17.8349 33.3667 17.8188ZM22.0019 11.6875C22.1634 11.7586 22.3464 11.7625 22.5107 11.6984C22.675 11.6344 22.8071 11.5075 22.8778 11.3459C23.0028 11.0601 23.1788 10.8022 23.4011 10.5792C23.8742 10.1044 24.503 9.84292 25.1716 9.84292C25.8403 9.84292 26.4691 10.1044 26.9421 10.5791C27.0839 10.7214 27.208 10.8794 27.3112 11.0491C27.4172 11.2234 27.5974 11.3393 27.7999 11.3634C28.0025 11.3874 28.2049 11.3173 28.349 11.1728L28.6902 10.8303C29.0221 10.4973 29.4631 10.3139 29.932 10.3139C30.401 10.3139 30.8419 10.4973 31.1737 10.8303C31.8604 11.5193 31.8604 12.6405 31.1737 13.3296L30.8325 13.6721C30.6891 13.8161 30.6195 14.0177 30.6436 14.2194C30.6676 14.4212 30.7828 14.6008 30.956 14.707C31.1249 14.8106 31.2824 14.9351 31.424 15.0771C32.1497 15.8055 32.3532 16.889 31.9704 17.8174H18.62C17.6533 17.1609 17.0816 16.0862 17.0816 14.9081C17.0816 12.9695 18.6562 11.3923 20.5914 11.3923C21.0824 11.3923 21.5569 11.4916 22.0019 11.6875ZM15.7536 14.9081C15.7536 15.9823 16.0986 16.9939 16.718 17.8174H13.0763L12.1408 12.8569C12.0086 12.1208 12.2079 11.3697 12.6874 10.7965C13.1657 10.2248 13.867 9.8969 14.6116 9.8969H16.7844C17.4276 9.8969 18.0231 10.1332 18.4775 10.5515C16.8662 11.3385 15.7536 12.9956 15.7536 14.9081ZM13.3587 4.88144C13.7019 4.79292 13.9151 4.45066 13.8432 4.10362C13.8169 3.97699 13.8036 3.84636 13.8036 3.71535C13.8036 2.66878 14.6534 1.81739 15.6979 1.81739C16.7425 1.81739 17.5923 2.66878 17.5923 3.71535C17.5923 3.84623 17.579 3.97685 17.5527 4.10376C17.4808 4.45073 17.6941 4.79292 18.0371 4.88144C18.8734 5.09706 19.4574 5.85296 19.4574 6.7197C19.4574 7.76626 18.6076 8.61772 17.5631 8.61772C17.0348 8.61772 16.5444 8.40509 16.1823 8.019C16.0568 7.88513 15.8815 7.80922 15.698 7.80922C15.5145 7.80922 15.3392 7.88519 15.2136 8.019C14.8515 8.40502 14.3611 8.61772 13.8328 8.61772C12.7882 8.61772 11.9384 7.76626 11.9384 6.7197C11.9384 5.85296 12.5225 5.09706 13.3587 4.88144ZM9.50997 9.18974C10.3304 9.18974 11.1153 9.39049 11.8185 9.77565C11.7671 9.83023 11.7172 9.88648 11.6687 9.94438C10.9361 10.8202 10.6317 11.9673 10.8345 13.0973L11.7246 17.8174H8.77439C9.25291 17.0751 9.51894 16.2005 9.51894 15.3004C9.51894 13.0995 7.9803 11.2525 5.92536 10.7845C6.8336 9.78268 8.13384 9.18974 9.50997 9.18974ZM4.90277 11.9981C6.7158 11.9981 8.19088 13.4795 8.19088 15.3004C8.19088 16.2825 7.77106 17.1884 7.03156 17.8175H2.77399C2.03455 17.1884 1.61467 16.2825 1.61467 15.3004C1.61473 13.4795 3.08975 11.9981 4.90277 11.9981ZM17 32.1826C8.61488 32.1826 2.4996 26.7177 2.3454 19.1462H31.6545C31.5004 26.7177 25.3851 32.1826 17 32.1826Z" fill="#3A6659"></path></g><defs><clipPath id="clip0_211_1400"><rect width="34" height="34" fill="white"></rect></clipPath></defs></svg>',5:'<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8277 17.5886H10.8213C10.4654 17.592 10.1796 17.8834 10.183 18.2393L10.2085 20.865L8.14173 17.8752C7.98143 17.6433 7.68882 17.5425 7.4196 17.6265C7.15038 17.7105 6.96707 17.9597 6.96707 18.2418V22.8798C6.96707 23.2357 7.25569 23.5243 7.6116 23.5243C7.96751 23.5243 8.25613 23.2357 8.25613 22.8798V20.3076L10.2209 23.1498C10.4079 23.4196 10.7204 23.5342 11.0177 23.441C11.3202 23.3464 11.5157 23.0647 11.5157 22.7171L11.4722 18.227C11.4687 17.873 11.1808 17.5886 10.8277 17.5886Z" fill="#3A6659"/><path d="M29.2689 25.5619H26.8152C25.2524 25.5619 23.8796 26.391 23.1135 27.6325C22.7968 27.1192 22.3763 26.6763 21.8816 26.3335V9.74009C21.8816 9.62259 21.8495 9.50729 21.7887 9.40668L19.312 5.30868H20.1091C20.465 5.30868 20.7536 5.02006 20.7536 4.66415V0.644531C20.7536 0.288621 20.465 0 20.1091 0H4.85907C4.50316 0 4.21454 0.288621 4.21454 0.644531V4.66415C4.21454 5.02006 4.50316 5.30868 4.85907 5.30868H5.65623L3.17949 9.40668C3.11877 9.50729 3.08661 9.62259 3.08661 9.74009V32.3555C3.08661 32.7114 3.37523 33 3.73114 33H25.5675C27.964 33 29.9136 31.0504 29.9136 28.6539V26.2064C29.9135 25.8505 29.6249 25.5619 29.2689 25.5619ZM5.5036 1.28906H7.59008V1.914C7.59008 2.26991 7.8787 2.55853 8.23461 2.55853C8.59052 2.55853 8.87914 2.26991 8.87914 1.914V1.28906H11.8395V1.914C11.8395 2.26991 12.1282 2.55853 12.4841 2.55853C12.84 2.55853 13.1286 2.26991 13.1286 1.914V1.28906H16.089V1.914C16.089 2.26991 16.3776 2.55853 16.7335 2.55853C17.0894 2.55853 17.3781 2.26991 17.3781 1.914V1.28906H19.4645V4.01962H5.5036V1.28906ZM4.37561 27.0636H14.6909C15.0468 27.0636 15.3354 26.775 15.3354 26.4191V14.6938C15.3354 14.3379 15.0468 14.0492 14.6909 14.0492H4.37561V10.3847H14.6909C15.0468 10.3847 15.3354 10.0961 15.3354 9.74016C15.3354 9.38425 15.0468 9.09562 14.6909 9.09562H4.8737L7.16243 5.30875H17.8057L20.5925 9.91979V25.7249C20.217 25.6188 19.821 25.5619 19.412 25.5619H16.9581C16.6022 25.5619 16.3136 25.8505 16.3136 26.2064V28.6539C16.3136 29.8448 16.795 30.9252 17.5734 31.711H4.37561V27.0636ZM4.43626 25.7745V15.3383H14.0463V25.7745H4.43626ZM20.6598 31.7109C18.974 31.7109 17.6026 30.3396 17.6026 28.6539V26.8509H19.4119C21.0976 26.8509 22.469 28.2223 22.469 29.908V31.7109H20.6598ZM28.6244 28.6539C28.6244 30.3395 27.253 31.7109 25.5673 31.7109H23.7581V29.908C23.7581 28.2223 25.1294 26.8509 26.8152 26.8509H28.6244V28.6539Z" fill="#3A6659"/></svg>'};
  }

  componentWillMount() {
    this.props.socket.on('mobile_checkout', this.listener);
    this.props.socket.on('profile', this.listener);
  }

  componentDidMount() {
    let socket = this.props.socket;

    if (socket.connected) {
      this.initializeData();
    } else {
      socket.on('connect', this.initializeData);
    }

    if (typeof IntersectionObserver !== 'undefined') {
      this.observer = new IntersectionObserver(
        function(entries) {
          let visibleEntries = entries
            .filter(function(entry) {
              return entry.isIntersecting;
            })
            .sort(function(a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });

          if (visibleEntries.length > 0) {
            let activeId = visibleEntries[0].target.id;
            let activeStep = this.steps.findIndex(function(step) {
              return step.id === activeId;
            });

            if (activeStep !== -1) {
              this.setState({ activeStep: activeStep });
            }
          }
        }.bind(this),
        {
          threshold: 0.2,
          rootMargin: '-80px 0px -50% 0px'
        }
      );

      this.steps.forEach(
        function(step) {
          let section = document.getElementById(step.id);
          if (section) {
            this.observer.observe(section);
          }
        }.bind(this)
      );
    }
  }

  componentWillUnmount() {
    this.props.socket.removeListener('mobile_checkout', this.listener);
    this.props.socket.removeListener('profile', this.listener);

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initializeData = () => {
    let socket = this.props.socket;
    let dataArray = this.props.dataArray;
    let required = [
      'dietGroups',
      'planDayRange',
      'dietMealTypeDiscounts',
      'mealtypeMobCombinations',
      'dietListFull',
      'dietListByGroup',
      'productsList',
      'ingredientList',
      'dietMobileList',
      'dishGroups',
      'daysRangeMob',
      'typeList',
      'emirate',
      'emirateSlots',
      'commonVouchers',
      'priceList'
    ];

    let types = required.filter(function(item) {
      return !(item in dataArray);
    });

    if (types.length > 0) {
      this.props.spin();
      getArrays(socket, types);
    }
    this.getPriceType();

    let checkoutPlanParams = this.props.checkoutPlanParams || {};

    if (checkoutPlanParams.id) {
      browserHistory.push('/checkout/menus');
      return;
    }

    this.props.spin();
    this.getSampleData();
    this.getPending(this.props.user.user_id);
    if (this.state.dayCount !== undefined) {
      this.updateMealPlanId();
    }
  };

  getPending = function(userId) {
    this.props.socket.emit('mobile_checkout', {
      type: 'getPending',
      data: { user_id: userId }
    });
  };
  getSampleData = function() {
    this.props.socket.emit('mobile_checkout', {
      type: 'getSampleData'
    });
  };
  listener = response => {
    let type = response.type;
    let data = response.data;

    this.props.stop();

    switch (type) {
      case 'saveProfDataMobileOk':
        if (data) {
          let updateData = {};
          updateData[data.action] = data.value;
          this.props.updateUser(updateData);
        }
        break;
      case 'getPriceTypeOk':
        this.setState({priceType:data.price_type})
      break;
      case 'getSampleDataOk':
          this.props.updateDataArray(data.arrayDatas);
          this.setState({sampleData:data.meal_plans},this.updateMealPlanId);
      break;
      case 'getPendingOk':
        this.setInitialState();
        if (data && data.mealPlan !== undefined) {
          this.props.setCheckoutPlanParams(data.planParams);
          this.props.setCheckoutMealPlan(data.mealPlan);
        }
        break;

      default:
        break;
    }
  };

  setInitialState() {
    let dataArray = this.props.dataArray;
    let user = this.props.user;

    let ingredientList = dataArray.ingredientList;
    let dishGroups = dataArray.dishGroups;

    let dislikeList =
      user.dislikes && ingredientList
        ? this.formatSelectOption(user.dislikes, ingredientList)
        : [];

    let eliminateList =
      user.eliminate_groups && dishGroups
        ? this.formatSelectOption(user.eliminate_groups, dishGroups)
        : [];

    this.setState({
      dislikes: dislikeList,
      eliminate_groups: eliminateList
    },this.updateMealPlanId);
  }

  handleEliminateChange = value => {
    this.setState({
      eliminate_groups: value
    });

    this.saveProfile(
      value.map(function(item) {
        return parseInt(item.value, 10);
      }),
      'eliminate_groups'
    );
  };

  handleDislikeChange = value => {
    this.setState({
      dislikes: value
    });

    this.saveProfile(
      value.map(function(item) {
        return parseInt(item.value, 10);
      }),
      'dislikes'
    );
  };

  saveProfile = (data, action) => {
    let user = this.props.user;

    if (user.token) {
      this.props.socket.emit('profile', {
        type: 'getForDashboard',
        data: {
          userId: user.user_id,
          subtype: 'saveProfDataMobile',
          theaction: action,
          value: data,
          deviceType: 'web'
        }
      });
    } else {
      let updateData = {};
      updateData[action] = data;
      this.props.updateUser(updateData);
    }
  };

  handleDietGroupChange = data => {
    this.setState(data, this.updateMealPlanId);
  };

  setDietType = (diet, handle) => {
    this.setState({
      diet: diet.id,
      dietHandle: handle
    }, this.updateMealPlanId);
  };

  _addMealTypes = item => {
    let dataArray = this.props.dataArray;
    let typeList = dataArray.typeList || {};
    let dietListFull = dataArray.dietListFull || {};
    let mealType = this.state.mealType;
    let diet = this.state.diet;
    let type = typeList[+item] || {};
    let children = type.children;

    let selected;

    if (mealType.indexOf(+item) !== -1) {
      selected = mealType.filter(function(meal) {
        return meal !== +item;
      });

      if (
        children &&
        dietListFull[diet] &&
        dietListFull[diet].sides_id != null
      ) {
        selected = selected.filter(function(el) {
          return el != children.id;
        });
      }
    } else {
      selected = mealType.concat([+item]);

      if (
        children &&
        dietListFull[diet] &&
        dietListFull[diet].sides_id != null
      ) {
        selected.push(+children.id);
      }
    }

    selected.sort();

    this.setState(
      { mealType: selected },
      this.updateMealPlanId
    );
  };
  getPriceType = () => this.props.socket.emit('mobile_checkout', { type: 'getPriceType' });
  calcPrice = types => {
    const { priceType} = this.state;
    let priceList = this.props.dataArray.priceList;
    let diet = this.state.diet;
    let mealplanId = this.state.mealplanId;
   
    if (!priceList || !diet || !mealplanId || !types) {
      return 0;
    }
   
    return priceList
      .filter(function(el) {
        return (
          +el.diet_id === +diet &&
          +el.mealPlan_id === +mealplanId &&
          types.indexOf(+el.mealType_id) !== -1
        );
      })
      .reduce(function(acc, cur) { if(priceType){ return acc + +cur.newValue }else{ return acc + +cur.value } }, 0);
  };

  getDiscounts = (rangeId, daycount) => {
    let state = this.state;
    let dataArray = this.props.dataArray;
    let discounts = dataArray.dietMealTypeDiscounts;
    let vouchers = dataArray.commonVouchers;

    let combo = '';

    if (
      discounts &&
      discounts[state.diet] &&
      discounts[state.diet][state.mealTypeCom] &&
      discounts[state.diet][state.mealTypeCom][rangeId] !== undefined
    ) {
      combo =
        discounts[state.diet][state.mealTypeCom][rangeId];
    }

    let discount = 0;
    let discountPer = 0;
    let discountType = 0;
    let isMealTypeDis = 0;

    let vou =
      vouchers &&
      vouchers.find(function(item) {
        return +item.id === +combo;
      });

    let clearPrice =
      this.calcPrice(state.mealType) * +daycount;

    if (combo && vou) {
      let conditions = vou.conditions;

      if (conditions != null && conditions !== '') {
        if (
          typeof conditions === 'string' ||
          conditions instanceof String
        ) {
          try {
            conditions = JSON.parse(conditions);
          } catch (e) {
            conditions = [];
          }
        }

        isMealTypeDis = intersect(
          state.mealType,
          conditions
        ).length;
      }

      discount =
        vou.conditions != null &&
        conditions &&
        conditions.length > 0 &&
        isMealTypeDis
          ? this.calcPrice(conditions.map(String)) * +daycount
          : vou.type === 'fixed'
          ? +vou.value
          : vou.type === 'percent'
          ? (+vou.value / 100) * clearPrice
          : 0;

      discountPer = +vou.value;
      discountType = vou.type;
    }

    return {
      discount: discount,
      discountPrice: clearPrice - discount,
      discountPer: discountPer,
      discountType: discountType,
      isMealTypeDis: isMealTypeDis,
      vou: vou,
      savedAmount :(vou && vou.type === 'buyxgety')?(clearPrice/daycount)* +vou.free_days:discount,
      price: clearPrice,
      voucher_field: 'voucher_id',
      voucher_id: (vou || {}).id,
      clearPrice: clearPrice
    };
  };

  getPriceData = () => {
    let state = this.state;
    let dataArray = this.props.dataArray;
    let discounts = dataArray.dietMealTypeDiscounts;
    let vouchers = dataArray.commonVouchers;
   
    let clearPrice =
      this.calcPrice(state.mealType) * state.dayCount;
    
    let combo = '';

    if (
      discounts &&
      discounts[+state.diet] &&
      discounts[+state.diet][state.mealTypeCom] &&
      discounts[+state.diet][state.mealTypeCom][state.dayRangeId] !== undefined
    ) {
      combo =
        discounts[+state.diet][state.mealTypeCom][state.dayRangeId];
    }

    let discount = 0;
    let discountPer = 0;
    let discountType = 0;

    let vou =
      vouchers &&
      vouchers.find(function(item) {
        return +item.id === +combo;
      });

    if (combo && vou) {
      let conditions = vou.conditions;
      let isMealTypeDis = 0;

      if (conditions != null && conditions !== '') {
        if (
          typeof conditions === 'string' ||
          conditions instanceof String
        ) {
          try {
            conditions = JSON.parse(conditions);
          } catch (e) {
            conditions = [];
          }
        }

        isMealTypeDis = intersect(
          state.mealType,
          conditions
        ).length;
      }

      discount =
        conditions &&
        conditions.length > 0 &&
        isMealTypeDis
          ? this.calcPrice(conditions)
          : vou.type === 'fixed'
          ? +vou.value
          : vou.type === 'percent'
          ? (+vou.value / 100) * clearPrice
          : 0;

      discountPer = +vou.value;
      discountType = vou.type;
    }

    return {
      price: clearPrice,
      discountPrice: clearPrice - discount,
      savedAmount :(vou && vou.type === 'buyxgety')?(clearPrice/daycount)* +vou.free_days:discount,
      discountPer: discountPer,
      discountType: discountType,
      voucher_field: 'voucher_id',
      voucher_id: (vou || {}).id
    };
  };

  getDayRangeId = count => {
    let daysRangeMob = this.props.dataArray.daysRangeMob;
    count = parseInt(count, 10);

    let rangeId = 0;
    if (daysRangeMob) {
      Object.keys(daysRangeMob).forEach(function(mealplanId) {
        let range = daysRangeMob[mealplanId] || {};

        if (
          parseInt(range.min, 10) <= count &&
          parseInt(range.max, 10) >= count
        ) {
          rangeId = mealplanId;
        }
      });
    }

    return parseInt(rangeId, 10);
  };

  getMealPlanId = count => {
    
    const { planDayRange } = this.props.dataArray;
      count=parseInt(count);
      let planId=71;
      planDayRange && Object.keys(planDayRange).forEach((mealplanId, index) => {
            const { range_from, range_to } = planDayRange[mealplanId] || {};
            if(parseInt(range_from)<=count && parseInt(range_to)>=count){
              planId=mealplanId;
              return mealplanId;
            }
      });

      return parseInt(planId);
  };

  updateMealPlanId = () => {
    let dataArray = this.props.dataArray;
    let dayCount = this.state.dayCount;
    let mealType = this.state.mealType;
    let diet = this.state.diet;

    let combinations = dataArray.mealtypeMobCombinations || {};
    let typeList = dataArray.typeList || {};

    let childTypes = mealType
      .map(function(val) {
        let item = typeList[+val] || {};
        return item.children != null
          ? item.children.id
          : null;
      })
      .filter(function(el) {
        return el != null;
      });

    let mealTypeHandle = mealType
      .filter(function(el) {
        return childTypes.indexOf(el) === -1;
      })
      .sort(function(a, b) {
        return a - b;
      })
      .join('-');

    let combination =
      combinations[mealTypeHandle] !== undefined
        ? combinations[mealTypeHandle]
        : false;
   
    let mealPlanId = this.getMealPlanId(dayCount);
    let rangeId = this.getDayRangeId(dayCount);
    
    this.getDefaultDishes(diet, mealType);
    
    this.setState({
      dayRangeId: rangeId,
      mealplanId: mealPlanId,
      mealTypeCom: combination
    });
  };

  getDefaultDishes = (dietId, types) => {
    this.props.socket.emit('default_dishes', {
      type: 'get',
      data: {
        dietId: dietId,
        types: types
      }
    });

    this.props.socket.emit('custom_plan', {
      type: 'get',
      data: {
        diet_id: dietId,
        mealTypes: types
      }
    });
  };

  _addExcludedWeek = item => {
    item = String(item);

    let excluded = this.state.excluded;
    let weekday = this.state.weekday;
    let day = 7 - excluded.length;

    if (excluded.indexOf(item) !== -1) {
      if (day >= weekday) {
        alert('You can only select ' + weekday + ' days');
      } else {
        this.setState({
          excluded: excluded.filter(function(meal) {
            return meal != item;
          })
        });
      }
    } else {
      this.setState({
        excluded: excluded.concat([item])
      });
    }
  };

  handleScheduleChange = data => {
    this.setState(data, this.updateMealPlanId);
  };

  handleDurationChange = dayCount => {
    this.setState(
      {
        dayCount: parseInt(dayCount, 10),
        selectedDay: []
      },
      this.updateMealPlanId
    );
  };

  handleDateChange = value => {
    this.setState(
      { deliveryDate: value },
      this.updateValidateDate
    );
  };

  handleEmirateChange = value => {
    this.setState(
      {
        emirate_id: value.value,
        emirate: value
      },
      this.updateEmirateSolts
    );
  };

  handleSlotChange = value => {
    this.setState({
      slot_id: parseInt(value.value, 10),
      slot: value
    });
  };

  getAllProgramDays(baseDays) {
    return {
      Weekly: baseDays,
      Monthly: baseDays * 4,
      'Bi-Monthly (2 Months)': baseDays * 8,
      'Quarterly (3 Months)': baseDays * 12
    };
  }

  checkIsAllergiesOrDislike=(productsList,allergies,dislikes,dishid)=>{
                const { ingredients }= productsList?productsList[dishid] || {}:{};
                let is_allergies=false;
                if(ingredients!=undefined&&ingredients.length>0 && allergies!=undefined){
                    if (allergies.length>0) {
                      is_allergies = intersect(ingredients,allergies).length;
                    }
                    if(dislikes.length>0&&!is_allergies){
                      is_allergies = intersect(ingredients,dislikes).length;   
                    }
                    if(!is_allergies){
                      return  dishid;
                    }
                    return  null;
                  }else{
                    return  dishid;
                  }
 };

  getDish = (date, type,existDish,defaultDishes,sideId=false) => {
            const day = moment.unix(date).date() - 1; // TODO: check logic
            const { user, customPlans,checkoutMealPlan:existMealPlan,checkoutMealPlanSides:existMealPlanSides,dataArray,customPlanSides} = this.props;
            const { productsList } = dataArray;
              
              if(sideId){
                if(
                  existMealPlanSides[+type] != undefined &&
                  existMealPlanSides[+type][day] != undefined &&
                  existMealPlanSides[+type][day][sideId] != undefined
                ){
                  return +(existMealPlanSides[+type][day][sideId])||null;
                }
              }else{
                  if(existMealPlan!=undefined && existMealPlan[date]!=undefined && existMealPlan[date][type]!=undefined && existMealPlan[date][type]!=0){
                      return +existMealPlan[date][type];
                  }
              }
               
               
                const sameDayDish = Object.values(existDish).map(Number);
                const plan = (sideId)?(customPlanSides.find(el => +el.mealType_id === +type && +el.side_type_id == +sideId ) || {}):(customPlans.find(el => +el.mealType_id === +type) || {});
                let dish=+(defaultDishes[+type] || {})[day] || null;
                if(sideId){
                  if(defaultDishes[+type]!=undefined&&defaultDishes[+type][day]!=undefined&&defaultDishes[+type][day][sideId]!=undefined){
                    dish=+(defaultDishes[+type][day][sideId])||null;
                  }
                }
                /* Start Disable the dislike/allergies dish */
                  let prodKeys = (plan.data || {})[day] || [];
          
                  const {allergies,dislikes,dishdislikes,eliminate_groups}=user;
          
                  let is_allergies=this.checkIsAllergiesOrDislike(productsList,allergies,dislikes,dish);
          
                  if(eliminate_groups!=undefined){
                    if(eliminate_groups.length>0 && is_allergies){
                  
                      const { group,spicy } =productsList[dish] || {};
                      // is_allergies=(eliminate_groups.indexOf(group)>-1)?null:dish;
                      is_allergies=(intersect(group,eliminate_groups).length>0)?null:dish;
                      if(is_allergies){
                        is_allergies=(eliminate_groups.indexOf(14)>-1 && spicy==1)?null:dish; // Spicy Group and dish set as spicy
                      }
                     
                    }
                  }
                  if(dishdislikes!=undefined){
                    if(dishdislikes.length>0 && is_allergies){
                      is_allergies=(dishdislikes.indexOf(+dish)>-1)?null:dish;
                    }  
                  }
                  
                  if(sameDayDish.length>0 && is_allergies){
                    is_allergies=(sameDayDish.indexOf(+dish)>-1)?null:dish;
                  }
                 
                  if(is_allergies!=null){
                    return +dish;
                  }else{
                    prodKeys=prodKeys.filter(function (dishId) {
                        const { group,spicy } = productsList[dishId] || {};
                        let isEliminate = true;
                        if(eliminate_groups!=undefined){
                            if(eliminate_groups.length>0){ 
                              // isEliminate = !(eliminate_groups.indexOf(group)>-1); 
                                isEliminate = !intersect(group,eliminate_groups).length;   
                              if(isEliminate){
                                isEliminate=!(eliminate_groups.indexOf(14)>-1 && spicy==1); // Spicy Group and dish set as spicy
                              }
                            }
                          }
                          
                        if(dishdislikes!=undefined){
                          if(dishdislikes.length>0 && isEliminate){
                            isEliminate = !(dishdislikes.indexOf(+dishId)>-1); 
                          }
                        }
                        return +isEliminate;
                    });
                    
                    var validDish = prodKeys.find((dishId, idx) => {
                      if(dishId!=dish){
                        let is_allergies=this.checkIsAllergiesOrDislike(productsList,allergies,dislikes,dishId);
                        if(sameDayDish.length>0 && is_allergies){
                          is_allergies=(sameDayDish.indexOf(+dishId)>-1)?null:+dishId;
                        }
                        if(is_allergies!=null||(prodKeys.length-1)==idx){
                          return +dishId;
                        }
                      }
                    });
                    return (validDish != undefined )?+validDish:+dish; // Set default dish,If the all dish are dislike/allergies
                  }
                 /* End Disable the dislike/allergies dish */
          
  }

  fillDefaults = (checkoutMealPlan,defaultDishes,defaultDishSides) => {
              const { checkoutPlanParams, dataArray} = this.props;
              const { sidesTypes, typeList,dietListFull } = dataArray;
              const { mealType: types,diet:diet_id } = this.state;
              var newmealType=types;
              const { sides_id  } = dietListFull[diet_id] || null;
              return Object.keys(checkoutMealPlan).reduce((acc, date) => {
                const dayData = newmealType.reduce((acc, type) => {
                  const { parent_id, title} = typeList[type];
                     if(parent_id!=0){
                      const sideData = sides_id!=null && Object.keys(sidesTypes).filter(function (sideId) {
                        return (sides_id.indexOf(sideId)>-1);
                    }).reduce((acc2, sideId) => {
                              return {...acc2, [+sideId]:this.getDish(date, type,acc2,defaultDishSides,sideId) };
                        }, {});
      
                      return { ...acc, [+type]:sideData };
                     }else{
                      return { ...acc, [+type]: this.getDish(date, type,acc,defaultDishes) };
                     }
                  
                }, {});
                // console.log(dayData);
                return { ...acc, [+date]: dayData };
              }, {});
            }
          fillPlanDates = (startDate, count, excludedDays) => {
              startDate =startDate;
              excludedDays =(excludedDays)?excludedDays:[];
              const includedDays = Array(7).fill(0).map((el, key) => key).filter(el => !excludedDays.includes(String(el)));
              let dates = {};
              if(count>0 && startDate){
                  for (let i = 0; i < count; i++) {
                    startDate = moment.unix(this.getinitialDate(includedDays,(i==0)?startDate:startDate+3600*24)).unix();
                    dates[startDate] = {};
                  }
              }
              return dates;
            };
          getValidDate = (initdate,excludedDays) =>{
                  if(excludedDays && excludedDays.length>0 && excludedDays.length<7){
                      if(excludedDays.includes(initdate.day())||excludedDays.includes(String(initdate.day()))){
                        return this.getValidDate(initdate.add(1,'day'),excludedDays);
                      }else{
                        return initdate;
                      }
                  }else{
                    return initdate;
                  }
            } 
           getinitialDate=(includedDays,startDate)=>{
              var initialDate = moment.unix(startDate);
              if(includedDays.includes(initialDate.weekday())){
                return startDate;
              }else{
                 return this.getinitialDate(includedDays,startDate+3600*24);
              }
            }; 
       updateEmirateSolts = () =>{
          const { dataArray } = this.props;
          const { emirateSlots } = dataArray;
          const { emirate_id } = this.state;
          const slotList =[];
           (emirateSlots && emirate_id && emirateSlots[emirate_id]) && emirateSlots[emirate_id].reduce((obj, key) => {
              slotList.push({label:key.display_name,value:key.id});
          }, []);
          // console.log(slotList);
          this.setState({slotList,slot:[],slot_id:''});
      }
      updateValidateDate =()=>{
              const { checkoutPlanParams } = this.props;
              const { exclude_week_day } = checkoutPlanParams;
              const { deliveryDate } = this.state;
              var reDate = this.getValidDate(moment.unix(deliveryDate),exclude_week_day).unix();
              this.setState({deliveryDate:reDate});
       }

  savePlan = (checkoutMealPlan) =>{
            const { checkoutPlanParams,user } =this.props;
            const { priceDatas } = checkoutPlanParams;
            const { slot_id, emirate_id } =this.state;
            // console.log('checkoutPlanParams');
            // console.log(checkoutPlanParams);
            // console.log(checkoutMealPlan);
            let checkDates = Object.keys(checkoutMealPlan);
            let checkOutdata ={...checkoutPlanParams,user_id:user.user_id,full_price:priceDatas.price,discount_price:priceDatas.savedAmount,slot_id:slot_id,source_type:'web',emirate:emirate_id,start_date:checkDates[0],end_date:checkDates[(checkDates.length)-1]};
            // console.log(checkOutdata); 
            // console.log(checkoutMealPlan);
            this.props.socket.emit('mobile_checkout', { type: 'set',   data: {
              checkoutPlanParams:checkOutdata,
              detailsData: checkoutMealPlan
            }});
            // props.stop();
         }

  validate = ()=>{
          const { dataArray, updateCheckoutPlanParams, checkoutPlanParams, setCheckoutPlanParams, defaultDishes,defaultDishSides } = this.props;
          const { mealtypeMobCombinations,typeList } = dataArray;
          const { mealType,mealplanId,dayCount,excluded, diet,deliveryDate,emirate_id, slot_id,bag_price } = this.state;
          let isValid = true;
          const { dietMobileList } = dataArray;
          if(!diet){
              alert('Please select diet type to continue');
              return false;
          }else{
              let mealTypeList = dietMobileList.filter((value)=>(value.id ==diet  && value.mealtypes)); 
              // console.log('mealTypeList');
              // console.log(mealTypeList);
              if(mealTypeList[0].mealtypes.length<=0){
                  alert("Please select different diet type. Currently, don't have meals");
                  return false;
              }else{
                  checkoutPlanParams && updateCheckoutPlanParams({ 'diet_id': diet, modified: true });
                  !checkoutPlanParams && setCheckoutPlanParams({ 'diet_id': diet, modified: true });
              }
              
          }
          if(mealType.length>0){
            const childTypes= mealType.map((val)=>{
              const { children } = typeList[+val];
              return (children!=null)?children.id:null;
          }).filter((el)=>{ return el != null; });
          // console.log(mealType);
          // console.log(childTypes);
            let name='mealTypes';
            let mealTypeHandle= mealType.filter((el)=>{ return !childTypes.includes(el);}).sort(function(a, b) {
              return a - b;
            }).join('-');
            isValid = (mealtypeMobCombinations && mealtypeMobCombinations[mealTypeHandle]!=undefined) ?mealtypeMobCombinations[mealTypeHandle]:false;
            if(isValid){
              updateCheckoutPlanParams({ [name]: mealType, modified: true });
            }else{
              alert(
                'Minimum 1 Main Meal required. Please select at least 1 main meal or some other combination.'
              )
            }
          }else{
            isValid =false;
           alert(
              'Please select mealType.'
            )
          } 
          if(dayCount){
            let name='days_count';
            updateCheckoutPlanParams({ [name]: dayCount, mealPlan_id: mealplanId});
          }else{
            isValid =false;
            alert(
              'Please select day.')
          }
          if(deliveryDate){
            let name='date';
            if(deliveryDate!=checkoutPlanParams.date){
               updateCheckoutPlanParams({ [name]: deliveryDate, modified: true});
            }
          }else{
            isValid =false;
            alert(
              'Please select delivery Date.',
            )
            return false;
          }
          if(emirate_id){
            let name='emirate';
            if(emirate_id!=checkoutPlanParams.emirate){
                updateCheckoutPlanParams({ [name]: emirate_id, modified: true});
            }
          }else{
            isValid =false;
            alert(
              'Please select emirate.',
            )
            return false;
          }
          if(slot_id){
            let name='slot_id';
            // if(slot_id!=checkoutPlanParams.slot_id){
               updateCheckoutPlanParams({ [name]: slot_id, modified: true});
            // }
          }else{
            isValid =false;
            alert(
              'Please select delivery slot.',
            )
            return false;
          }
          if(isValid){
            const { vou } = priceDatas || {};
            let daysCount = parseInt(dayCount);
            if(vou && vou.type=='buyxgety' && dayCount==vou.buy_days){
                daysCount+=parseInt(vou.free_days);
            }
            let checkoutMealPlanData = this.fillPlanDates(deliveryDate,daysCount,excluded);
            let checkoutMealPlan = this.fillDefaults(checkoutMealPlanData,defaultDishes,defaultDishSides);
            this.props.setCheckoutMealPlan(checkoutMealPlan);
            const priceDatas = this.getPriceData();
             updateCheckoutPlanParams({diet_id:diet, price:priceDatas.discountPrice,voucher_field:'voucher_id',voucher_id:priceDatas.voucher_id,priceDatas,exclude_week_day:excluded,days_count:dayCount,mealplanId,start_date:Object.keys(checkoutMealPlan)[0],end_date:Object.keys(checkoutMealPlan)[(Object.keys(checkoutMealPlan).length)-1] , modified: true,slot_id:slot_id,emirate:emirate_id,bag_price:bag_price});
              const { token } = this.props.user;
              if(token){
                this.props.spin();
                this.savePlan(checkoutMealPlan);
              }else{
                browserHistory.push('/checkout/menus');
              }
          }
          return isValid;
      };

  formatSelectOption(list, dataList) {
    let result = [];

    if (list) {
      list.forEach(function(val) {
        result.push({
          label: dataList[val],
          value: parseInt(val, 10)
        });
      });
    }

    return result;
  }

  scrollToStep = id => {
    let element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  renderMealplanPopup= (value,handle,data) =>{
      const {setModal, clearModal,dataArray} = this.props;
      const title = value.display_name || value.name;
      return (
              setModal({ headLine:title,type:"sample-menu",isAligncenter:false,sizemodal:8, message: (
                                        <Fragment><SampleMenu value={value} handle={handle} plan={data}  title={title} dataArray={dataArray} setModal={setModal} clearModal={clearModal} setDietType={
                          this.setDietType
                        } /> </Fragment>
              )})
      )
    }
  render() {
    let dataArray = this.props.dataArray;
    let priceDatas = this.getPriceData();

    return (
      <Fragment>
        <div className="main-holder checkout-process-con wrap-progress-page">
          <div className="container checkout-process step1">
            <div className="row">
              <div className="col-12">
                <div className="inner-content">
                  <header className="meal-header">
                    <h1>
                      Start Your Custom Meal Plan
                    </h1>
                    <div className="food-preview">
                        <img
                          src={headImg1}
                          alt="Meal"
                        />
                        <img
                          src={headImg2}
                          alt="Meal"
                        />
                        <img
                          src={headImg3}
                          alt="Meal"
                        />
                      </div>
                  </header>

                  <MealProgress
                    steps={this.steps}
                    activeStep={this.state.activeStep}
                    onStepChange={index =>
                      this.setState({
                        activeStep: index
                      })
                    }
                    scrollToStep={
                      this.scrollToStep
                    }
                  />

                  <div className="prd-customizer">
                    <div className="pcustom-left">
                      <DietGroups
                        dataArray={dataArray}
                        diet_group={
                          this.state.diet_group
                        }
                        dietGroupIcons={this.dietGroupIcons}
                        diet={
                          this.state.diet
                        }
                        onChange={
                          this.handleDietGroupChange
                        }
                      />

                      <DietTypes
                        dataArray={dataArray}
                        diet={
                          this.state.diet
                        }
                        sampleData={this.state.sampleData}
                        diet_group={
                          this.state.diet_group
                        }
                        dietGroupList={
                          this.state.dietGroupList
                        }
                        renderMealplanPopup={this.renderMealplanPopup}
                        setDietType={
                          this.setDietType
                        }
                      />

                      <MealTypes
                        dataArray={dataArray}
                        diet={
                          this.state.diet
                        }
                        mealType={
                          this.state.mealType
                        }
                        onMealTypeChange={
                          this._addMealTypes
                        }
                      />

                      <Schedule
                        excluded={
                          this.state.excluded
                        }
                        weekday={
                          this.state.weekday
                        }
                        onExcludedChange={
                          this._addExcludedWeek
                        }
                        onWeekdayChange={
                          data =>
                            this.handleScheduleChange(
                              data
                            )
                        }
                      />

                      <Duration
                        dayCount={
                          this.state.dayCount
                        }
                        weekday={
                          this.state.weekday
                        }
                        getDayRangeId={
                          this.getDayRangeId
                        }
                        getDiscounts={
                          this.getDiscounts
                        }
                        onChange={
                          this.handleDurationChange
                        }
                      />

                      <Delivery
                        deliveryDate={
                          this.state.deliveryDate
                        }
                        emirate={
                          this.state.emirate
                        }
                        emirate_id={
                          this.state.emirate_id
                        }
                        slot={
                          this.state.slot
                        }
                        slot_id={
                          this.state.slot_id
                        }
                        slotList={
                          this.state.slotList
                        }
                        dataArray={dataArray}
                        onDateChange={
                          this.handleDateChange
                        }
                        onEmirateChange={
                          this.handleEmirateChange
                        }
                        onSlotChange={
                          this.handleSlotChange
                        }
                      />

                      <Extras
                        bag_price={
                          this.state.bag_price
                        }
                        onChange={
                          this.onChange
                        }
                      />
                    </div>

                    <div className="pcustom-left">
                      <OrderSummary
                        dietGroupIcons={this.dietGroupIcons}
                        dataArray={dataArray}
                        priceDatas={priceDatas}
                        {...this.state}
                        continueValid={
                          this.validate
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  onChange = (name, value) => {
    let state = {};
    state[name] = value;
    this.setState(state);
  };
}

MealPlans.propTypes = {
    checkoutPlanParams: PropTypes.object.isRequired,
    checkoutMealPlan: PropTypes.object.isRequired,
    setCheckoutMealPlan: PropTypes.func.isRequired,
    setCheckoutPlanParams: PropTypes.func.isRequired,
    dataArray: PropTypes.object.isRequired
};
  
const mapStateToProps = state => ({
    checkoutPlanParams: state.checkoutPlanParams,
    dataArray: state.dataArray,
    user:state.user,
    planParams: state.planParams,
    checkoutMealPlan: state.checkoutMealPlan,
    checkoutMealPlanSides: state.checkoutMealPlanSides,
    defaultDishes: state.defaultDishes,
    defaultDishSides: state.defaultDishSides,
    customPlans: state.customPlans,
    customPlanSides: state.customPlanSides
});

const bindAction = dispatch => ({
    setCheckoutMealPlan: plan => dispatch(setCheckoutMealPlan(plan)),
    setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
    updateCheckoutPlanParams: obj => dispatch(updateCheckoutPlanParams(obj)),
    updateDataArray: arr => dispatch(updateDataArray(arr)),
    spin: () => dispatch(spin()),
    stop: () => dispatch(stop()),
    updateCheckoutMealPlan: (date,obj) => dispatch(updateCheckoutMealPlan(date,obj)),
    updateUser: user => dispatch(userUpdate(user)),
     setModal: data => dispatch(setModal(data)),
     clearModal: data => dispatch(clearModal(data)),
});
  
export default socketConnect(connect(mapStateToProps, bindAction)(MealPlans));
